(function() {
  'use strict';
  angular.module('common')
  .directive('autofocus', function($timeout) {
    return {
      restrict: 'A',
      link: function ( scope, element, attrs ) {
        scope.$watch( attrs.autofocus, function ( val ) {
          if (!angular.isDefined(val) || (val && val !== 'false')) {
            $timeout(function () { 
              element[0].focus(); 
            });
          }
        }, true);
      }
    };
  });
})();